import type { MeetingResponse } from "@alm/domain";

/** How a meeting's own answer reads on the calendar: never by colour alone. */
export const RESPONSE_LABEL: Record<MeetingResponse, string> = {
  accepted: "Going",
  tentative: "Maybe",
  declined: "Not going",
  pending: "Not answered",
};

export const ATTENDEE_RESPONSE_LABEL: Record<MeetingResponse, string> = {
  accepted: "Yes",
  tentative: "Maybe",
  declined: "No",
  pending: "Awaiting",
};

export const MEETING_VIEWS = ["day", "week", "month", "list"] as const;
export type MeetingView = (typeof MEETING_VIEWS)[number];
const VIEW_KEY = "alm.meetings.view";

export function storedView(): MeetingView {
  try {
    const stored = window.localStorage.getItem(VIEW_KEY);
    return MEETING_VIEWS.some((view) => view === stored) ? (stored as MeetingView) : "week";
  } catch {
    return "week";
  }
}

export function keepView(view: MeetingView): void {
  try {
    window.localStorage.setItem(VIEW_KEY, view);
  } catch {
    // A private window keeps no preference.
  }
}

/** "4 yes, 1 maybe, 2 awaiting", leaving out what is zero. */
export function responseCounts(attendees: ReadonlyArray<{ response: MeetingResponse }>): string {
  const count = (response: MeetingResponse) =>
    attendees.filter((attendee) => attendee.response === response).length;
  const parts = [
    [count("accepted"), "yes"],
    [count("tentative"), "maybe"],
    [count("declined"), "no"],
    [count("pending"), "awaiting"],
  ] as const;
  return parts
    .filter(([value]) => value > 0)
    .map(([value, word]) => `${value} ${word}`)
    .join(", ");
}
